export default async ({to, next, store, nextMiddleware }) => {

    if(!localStorage.getItem('accessToken')) {
        await store.dispatch('logout')

        store.commit('setAttemptUrl', to.fullPath)

        return next({name: 'Login'})
    }

    else if(!store.getters.isAuthenticated) {
        await store.dispatch('fetchCurrentUser').then(() => {
            return nextMiddleware();
        }).catch(() => {
            store.dispatch('logout')

            store.commit('setAttemptUrl', to.fullPath)

            return next({name: 'Login'})
        });
    }

    else return nextMiddleware()
}
